import React, { useCallback, useState } from 'react';
import { Tabs as MaterialTabs, Tab } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Props } from './Tabs.types';
import styles from './Tabs.module.scss';
import { Theme } from '@material-ui/core';

export interface StyleProps {
  top: number;
}

const useTabsStyles = makeStyles({
  indicator: {
    backgroundColor: '#CB7813',
  },
});

const useTabsStickyStyles = makeStyles<Theme, StyleProps>((theme) => ({
  root: {
    position: 'sticky',
    zIndex: 2,
    top: ({ top }) => top,
    backgroundColor: '#f9f9f9',
  },
  indicator: {
    backgroundColor: '#CB7813',
  },
}));

const useSingleTabStyles = makeStyles({
  root: {
    fontSize: '16px',
    textTransform: 'none',
    minWidth: 'auto',
    paddingLeft: 0,
    '&:not(:first-child)': {
      marginLeft: '16px',
    },
  },
  wrapper: {
    alignItems: 'flex-start',
  },
  selected: {
    color: '#CB7813',
  },
});

const Tabs: React.FC<Props> = ({
  onTabChange,
  activeTab = 0,
  labels,
  children,
  isSticky = false,
  stickyTop = 0,
  tabsContentGap = 24,
  isDisabled = false,
}) => {
  const tabsClasses = useTabsStyles();
  const tabsStickyClasses = useTabsStickyStyles({ top: stickyTop });
  const singleTabClasses = useSingleTabStyles();
  const [activeTabNumber, setActiveTabNumber] = useState<number>(activeTab);
  const tabPanelsCount = React.Children.count(children);

  const handleChange = (event: React.ChangeEvent<{}>, value: any) => {
    setActiveTabNumber(value);

    if (typeof onTabChange === 'function') {
      onTabChange(value);
    }
  };

  const getTabPanel = useCallback(
    (activeTabNumber) => {
      return React.Children.toArray(children)[activeTabNumber];
    },
    [children],
  );

  return (
    <>
      <MaterialTabs
        classes={isSticky ? tabsStickyClasses : tabsClasses}
        className={styles.tabs}
        value={activeTabNumber}
        onChange={handleChange}
        aria-label="tabs">
        {labels.map((label) => (
          <Tab
            classes={singleTabClasses}
            className={styles.tab}
            key={`label-value-${label.value}`}
            label={`${label.value}${label.hasError ? ' (amends required)' : ''}`}
            disabled={isDisabled}
          />
        ))}
      </MaterialTabs>
      {tabPanelsCount > 0 && (
        <div className={styles.tabPanel} style={{ marginTop: tabsContentGap }}>
          {getTabPanel(activeTabNumber)}
        </div>
      )}
    </>
  );
};

export default Tabs;
